var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAirTransport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Airplane_Envirotainer_Purple",
    transform: "matrix(1.1,0,0,1.1,-92,-92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Airplane_White_1_",
    fill: "#FCFCFC",
    d: "M549.8,235.1L549.8,235.1c0-16-10.9-23.9-28.8-28.2l-74.5,34.3l1.2-16.2l48.3-21.8 c-6.9-0.5-14-0.7-21.1-0.7c-26.7,0-71.8,13.5-121.6,33.3l-159.9-42.2c-14.9-3.9-30.8-1.5-43.9,6.7l-7.9,4.9c-1.5,1-2.9,2.3-3.9,3.8 c-3.7,5.8-2.1,13.4,3.7,17.2l96.1,62.4c-23,11.7-44.7,23.7-63.9,35l-49.3-26.1c-8-4.3-17.6-4.8-26-1.4l-4.7,1.9 c-0.5,0.2-1,0.4-1.5,0.7c-6,3.4-8.1,10.9-4.7,16.9l27.2,48.3c-10.3,8.8-16.1,16.1-16.1,21.2c0,15.1,18.6,18.9,35.1,18.9 c14.5,0,117.2-21.8,216.9-53.6c9,19.9,64.5,91,64.5,91c3.6,4.1,9.5,5.4,14.5,3.1l8.1-3.7c14.6-6.8,23.1-22.1,21.3-38.1l-7.3-89.4 C508.3,288.5,549.8,261.3,549.8,235.1z M362,351.6l-1.8-3.6l82.9-30.7l1.5,4.3L362,351.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirTransport);
export default __webpack_public_path__ + "static/media/air-transport.9165998504d9a5d8550aa6de414cb843.svg";
export { ForwardRef as ReactComponent };